define.alias("shared/components/shared/profile-categorization/modal", "settings/components/shared/profile-categorization/modal");